export enum ProductType {
  LineSkip,
  Drink,
  Cover,
  Legacy,
  Other
}
